import { Controller } from "@hotwired/stimulus"

// Announces a deck slide's CURRENT feedback state to the rest of the page,
// every time this element enters the DOM (card #2536) — mirrors
// slide_review_status_controller.js's own pattern exactly, one level further.
//
// decks/_slide_feedback_dot is server-rendered inline for every slide on
// initial page load, AND turbo_stream.replace'd by
// deck_slide_feedbacks/_refresh.turbo_stream.erb every time a comment is
// posted OR a resolved-toggle changes — Turbo swaps in a fresh element
// carrying this SAME data-controller attribute, so connect() fires again with
// the fresh state baked in from the server.
//
// airdrop_report_viewer_controller.js listens for the "slide-feedback:updated"
// document event this dispatches to keep its own cached
// data-has-open-feedback/data-has-resolved-feedback attributes (read once at
// initial render, driving the show page's feedback-state filter — card
// #2536) in sync live, WITHOUT a page reload. Without this, a comment posted
// or resolved while a feedback filter was active would leave the slide's
// filter membership stale until a full reload — the same quality gap
// onSlideReviewUpdated closed for the review-status filter.
export default class extends Controller {
  static values = {
    slideUuid: String,
    hasOpenFeedback: Boolean,
    hasResolvedFeedback: Boolean
  }

  connect() {
    document.dispatchEvent(new CustomEvent("slide-feedback:updated", {
      detail: {
        slideUuid: this.slideUuidValue,
        hasOpenFeedback: this.hasOpenFeedbackValue,
        hasResolvedFeedback: this.hasResolvedFeedbackValue
      }
    }))
  }
}
